import { FormikProps } from 'formik'
import { FC, useState, useEffect, useCallback } from 'react'
import { AgGridTable } from '../../../utils/agGridTable/AgGridTable'
import { Button } from '../../../utils/Button'
import ArrayInput from '../../../utils/form/ArrayInput'
import { useBetween } from 'use-between'
import { propsInterfaceFormGroupInput } from '../../../utils/form/FormGroupInput'
import { BTCreateContract3 } from '../BTContract/BTCreateContract3'
import { BTCreateContract2 } from '../BTContract/BTCreateContract2'
import { ActionDataGrid3 } from './ActionDataGrid3'
import { ModalForm } from '../../../utils/modal/ModalForm'
import { options } from '../../../utils/form/autocompleteDTO'
import { warn } from '../../../utils/customToasd'
import { callSP } from '../../../../setup/axios/AxiosCallSP'
import { quitarDuplicadoReceta } from '../../minutas/grillas/gridService'
import {
  editStepGrid,
  getColumRecetaGrid,
  isValid,
  mapDaysStr,
  validateIngredientsFrequency,
} from './step.service'
import { setLStorage, getLStorage, get_set_ls, setSStorage, getSStorage } from 'global.d'
import { useLocation } from 'react-router-dom'

const StepContract3: FC<StepContract3Props> = (props) => {

  const [infoModal, setInfoModal] = useState<boolean>(false)
  const { setDataRow3, dataRow3, setIngByCeco } = useBetween(BTCreateContract3)
  const { dataRow2 } = useBetween(BTCreateContract2)
  const [addRow, setAddRow] = useState(false)
  const [isAdd, setIsAdd] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [open, setOpen] = useState(false)
  const [dias, setDias] = useState<any>([])
  const [ciclos, setCiclos] = useState<any>([])
  const [ingredientes, setIngredientes] = useState<any>([])
  const [recetas, setRecetas] = useState<any>([])
  const [mapRec, setMapRec] = useState<any>([])
  const columInput = 5
  const columInputModal = 2
  const [arrayInput, setArrayInput] = useState<propsInterfaceFormGroupInput[]>([])
  const [btnStructure, setBtnStructure] = useState(props.title)
  const [arrayInputKey, setArrayInputKey] = useState<number>(0) // Key para forzar re-render cuando se edita
  const [gridRef, setGridRef] = useState<any>()
  const [columnDefs, setColumnDefs] = useState<any>([])

  const [rowSelected, setRowSelected] = useState<any>([])
  const [disabledInput, setDisabledInput] = useState(false)
  const location = useLocation()
  let _state: any = {}
  useEffect(() => {
    setSStorage("idMainIngredients", '')
    setSStorage("weeksQty", '')
    setLStorage('idRecetaFija', '')
    const state: any = location.state
    if (state?.params) {
      const contract = {
        ...state?.params,
        id: state?.contrato,
      }
      _state = contract
      if (contract?.plantilla > 0 || contract?.minuta > 0) {
        setDisabledInput(true)

      }
    }
  }, [])

  useEffect(() => {
    setColumnDefs([
      { field: 'id', hide: true },
      { field: 'fatherStructure2', headerName: 'Estructura Padre', minWidth: 180 },
      { field: 'dietaryCategory2', headerName: 'Categoria Dietetica', minWidth: 180 },
      { field: 'mainIngredients', headerName: 'Ingrediente Principal', minWidth: 150 },
      { field: 'recipe', headerName: 'Receta', minWidth: 160 },
      { field: 'cycleWeek', headerName: 'Semanas', minWidth: 150 },
      { field: 'diaReceta', headerName: 'Días', minWidth: 150 },
      { field: 'intercalaryWeek', headerName: 'Tipo', minWidth: 150, hide: (props.formikProps?.values?.templateType[0]?.value != 3) },
      {
        field: 'Acción',
        minWidth: 150,
        cellRenderer: (params: any) => {
          return (
            <>
              {editStepGrid(params, callbackEdit)}
              {props.estate.plantilla > 0 ? "" : <ActionDataGrid3 dataRow={params.node.data} />}
            </>
          )
        },
        cellEditor: 'agRichSelectCellEditor',
        cellEditorPopup: true,
      },
    ])
  }, [props.reload3])

  const [arrayInputModal] = useState<propsInterfaceFormGroupInput[]>([
    {
      columInput: columInputModal,
      campo: 'day1',
      label: 'Día 1',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day2',
      label: 'Día 2',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day3',
      label: 'Día 3',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day4',
      label: 'Día 4',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day5',
      label: 'Día 5',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day6',
      label: 'Día 6',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
    {
      columInput: columInputModal,
      campo: 'day7',
      label: 'Día 7',
      type: 'checkbox',
      className: 'form-check-input day-select',
      isSwitch: true,
    },
  ])

  const [initValuesModal] = useState<any>({
    day1: true,
    day2: true,
    day3: true,
    day4: true,
    day5: true,
    day6: false,
    day7: false,
  })

  const [ingredientSelected, setIngredientSelected] = useState<any>()
  const [estrPadreSelected, setEstrPadre] = useState<any>()
  const [catDie, setCatDie] = useState<any>()
  const [recSelected, setRecSelected] = useState<any>()

  const [estPadre, setEstPadre] = useState<any>([
    { index: 1, pf_codigo: 10006, pf_nombre: 'Plato Fondo 1', ac_codigo: 10015, ac_nombre: 'Acompañamiento 1' },
    { index: 2, pf_codigo: 10007, pf_nombre: 'Plato Fondo 2', ac_codigo: 10602, ac_nombre: 'Acompañamiento 2' },
    { index: 3, pf_codigo: 10075, pf_nombre: 'Plato Fondo 3', ac_codigo: 12027, ac_nombre: 'Acompañamiento 3' },
    { index: 4, pf_codigo: 13705, pf_nombre: 'Plato Fondo 4', ac_codigo: 12050, ac_nombre: 'Acompañamiento 4' },
    { index: 5, pf_codigo: 15614, pf_nombre: 'Plato Fondo 5', ac_codigo: 12051, ac_nombre: 'Acompañamiento 5' },
    { index: 6, pf_codigo: 15615, pf_nombre: 'Plato Fondo 6', ac_codigo: 36926, ac_nombre: 'Acompañamiento 6' },
    { index: 7, pf_codigo: 15616, pf_nombre: 'Plato Fondo 7', ac_codigo: 36927, ac_nombre: 'Acompañamiento 7' },
    { index: 8, pf_codigo: 15617, pf_nombre: 'Plato Fondo 8', ac_codigo: 36928, ac_nombre: 'Acompañamiento 8' },
  ])

  const callbackEdit = useCallback(
    (data: any) => {

      // get_set_ls("recFij", data.idRecetaFija)
      // get_set_ls("recFijRec", data.idRecipe)
      // get_set_ls("recFijCD", data.idDietaryCategory2)
      if (data.idRecetaFija) {
        setLStorage('idRecetaFija', data.idRecetaFija)
      }

      setLStorage("idEdit", data.id)
      // NO guardar cycleWeek en el storage porque solo contiene las semanas seleccionadas
      // En su lugar, mantener el storage con todas las semanas disponibles
      // setSStorage("weeksQty", data.cycleWeek) // COMENTADO: esto guarda solo las semanas seleccionadas
      setSStorage("idMainIngredients", data.idMainIngredients)
      setRowSelected(data)
      formStep3(true, data, true)
      setBtnStructure('Editar receta fija')
    },
    [
      dataRow2,
      ingredientSelected,
      estrPadreSelected,
      props.formikProps?.values.templateType,
      props.formikProps?.values.frequencyCycle,
      isAdd,
      ingredientes,
    ]
  )

  useEffect(() => {
    const serviceStep1 = props.formikProps?.values.place
    if (serviceStep1 && serviceStep1.length) {
      getRecipesByCeco(serviceStep1[0].value)
    }
  }, [props.formikProps?.values.place])

  const v3 = props.formikProps?.values
  useEffect(() => {
    if (props.isReady) {
      formStep3(false, [], true)
    }
  }, [
    props.isReady,
    dataRow2,
    ingredientSelected,
    estrPadreSelected,
    catDie,
    v3?.templateType?.[0]?.value,
    v3?.frequencyCycle,
    v3?.dietaryCategory2?.[0]?.value,
    isAdd,
    ingredientes,
  ])

  const formStep3 = (editForm: boolean, data?: any, editInput?: boolean) => {

    setDisabledInput(!editInput)
    const mapEstructuras = dataRow2.map((e: any) => {
      return {
        ...e,
        text: e.structure,
        value: e.id,
      }
    })
    let mapRecetas: any = []
    let mapIng: any = []
    if (estrPadreSelected && estrPadreSelected?.plateTypes) {
      if (ingredientes && ingredientes.length) {
        if (catDie) {
          mapIng = quitarDuplicadoReceta(
            ingredientes.filter(
              (e: any) => estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                catDie.value == e.rec_catdie
            ),
            'Idtipoingprincipal'
          )
        } else {
          mapIng = quitarDuplicadoReceta(
            ingredientes.filter(
              (e: any) => estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                estrPadreSelected.idDietaryCategory == e.rec_catdie
            ),
            'Idtipoingprincipal'
          )
        }
      }
    } else {
      if (ingredientes && ingredientes.length) {
        mapIng = quitarDuplicadoReceta(
          ingredientes.filter(
            (e: any) => dataRow2.findIndex((r: any) => r?.plateTypes.includes(e.rec_tippla)) != -1
          ),
          'Idtipoingprincipal'
        )
      }
    }

    if (ingredientSelected && estrPadreSelected?.plateTypes) {
      if (recetas && recetas.length) {
        if (catDie) {
          mapRecetas = quitarDuplicadoReceta(
            recetas.filter(
              (e: any) =>
                estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                catDie.value == e.rec_catdie &&
                ingredientSelected.Idtipoingprincipal == e.Idtipoingprincipal
            ),
            'rec_codigo'
          )
        } else {
          mapRecetas = quitarDuplicadoReceta(
            recetas.filter(
              (e: any) =>
                estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                estrPadreSelected.idDietaryCategory == e.rec_catdie &&
                ingredientSelected.Idtipoingprincipal == e.Idtipoingprincipal
            ),
            'rec_codigo'
          )
        }

      }
    } else {
      if (estrPadreSelected && estrPadreSelected?.plateTypes) {
        if (recetas && recetas.length) {
          if (catDie) {
            mapRecetas = quitarDuplicadoReceta(
              recetas.filter(
                (e: any) =>
                  estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                  catDie.value == e.rec_catdie
              ),
              'rec_codigo'
            )
          } else {
            mapRecetas = quitarDuplicadoReceta(
              recetas.filter(
                (e: any) =>
                  estrPadreSelected?.plateTypes.includes(e.rec_tippla) &&
                  estrPadreSelected.idDietaryCategory == e.rec_catdie
              ),
              'rec_codigo'
            )
          }
        }
      } else {
        if (recetas && recetas.length) {
          mapRecetas = quitarDuplicadoReceta(
            recetas.filter(
              (e: any) => dataRow2.findIndex((r: any) => r?.plateTypes.includes(e.rec_tippla)) != -1
            ),
            'rec_codigo'
          )
        }
      }
    }
    props.formikProps?.setFieldValue("idRecetaFija", data.idRecetaFija)
    const propCat = props.data.categoriaDieteticaRec

    const days: any = getDaysSelected()
    let mapDays: any[] = days
    if (estrPadreSelected) {
      mapDays = days.filter((d: any) => !estrPadreSelected.idBlockedDays?.includes(d.value))
    }

    if (editForm) {
      const mapEst = mapEstructuras.find(e => e.text === data.fatherStructure2)
      if (mapEst) {
        mapDays = days.filter((d: any) => !mapEst.idBlockedDays?.includes(d.value))
      }
    }

    // IMPORTANTE: Cuando se edita, SIEMPRE obtener todas las semanas disponibles
    // NO usar getSStorage('weeksQty') en modo edición porque podría tener solo las semanas seleccionadas
    let weeksQty: any[] = []
    if (editForm) {
      // Al editar, SIEMPRE generar todas las semanas disponibles desde el formulario
      setDias(mapDays)

      // Primero intentar obtener desde getWeeksSelected()
      weeksQty = getWeeksSelected()

      // Si está vacío, generar desde el valor de weeks del formulario
      if (weeksQty.length === 0) {
        const { weeks } = props.formikProps?.values || {}
        if (Number.isInteger(weeks) && weeks > 0) {
          for (let i = 1; i <= weeks; i++) {
            weeksQty.push({ text: `${i}`, value: `${i}` })
          }
        } else {
          // Si no hay weeks en el formulario, usar un valor por defecto de 4
          for (let i = 1; i <= 4; i++) {
            weeksQty.push({ text: `${i}`, value: `${i}` })
          }
        }
      }
    } else {
      // Al crear nuevo, usar el storage si existe, sino obtener todas
      const weeksQtyStorage = getSStorage('weeksQty');
      if (weeksQtyStorage) {
        weeksQty = weeksQtyStorage.split(',').map((item: string) =>
          ({ text: item, value: item })
        )
      } else {
        setDias(mapDays)
        weeksQty = getWeeksSelected()
      }
    }
    // IMPORTANTE: Siempre asegurar que weeksQty tenga todas las semanas disponibles
    // Esto es crítico para que el autocomplete muestre todas las opciones al editar
    setCiclos(weeksQty)
    let hideWeeks: boolean = false
    let inputsDisabled: boolean = false
    let hideIntercalaryWeek: boolean = true
    if (props.formikProps?.values.templateType && props.formikProps?.values.templateType.length) {
      const templateType: any = props.formikProps?.values.templateType[0].value
      if (templateType === 1) {
      }

      if (templateType === 2) {
        inputsDisabled = true
      }

      if (mapRecetas.findIndex((e: any) => e.valid == '-1') === -1) mapRecetas.push({ text: 'NO APLICA', value: '-1' })
      if (mapIng.findIndex((e: any) => e.valid == '-1') === -1) mapIng.push({ text: 'NO APLICA', value: '-1' })

      if (templateType === 3) {
        // hideWeeks = true
        hideIntercalaryWeek = false

        // mapRecetas.push({ text: 'NO APLICA', value: '-1' })
        // mapIng.push({ text: 'NO APLICA', value: '-1' })
      }
    }
    setMapRec(mapRecetas)

    const idMainIngredients = getSStorage('idMainIngredients');
    if (idMainIngredients) {
      mapRecetas = recetas.filter(
        (e: any) => e.Idtipoingprincipal === idMainIngredients
      )

    }
    // Construir el arrayInput con todas las semanas disponibles desde el inicio
    const arrayInputToSet = [
      {
        columInput: columInput,
        campo: 'fatherStructure2',
        label: 'Estructura Padre',
        type: 'autocomplete',
        //disabled: editInput,
        disabled: props.estate.plantilla > 0 ? true : false,
        advanceOptions: {
          id: 'fatherStructure2',
          multiple: false,
          placeholder: 'Ingrese Estructura',
          options: mapEstructuras,
        },
        onChange: async (event: any, setFieldValue: any, values: any) => {
          const structure: any = values.fatherStructure2[0]
          if (
            structure?.value != null &&
            structure?.value != undefined &&
            structure?.value !== ''
          ) {
            setEstrPadre(structure)
            if (structure.dietaryCategoryAll !== undefined)
              setFieldValue('dietaryCategory2', [{ text: structure.dietaryCategoryAll, value: structure.idDietaryCategory }])
          } else {
            setEstrPadre(null)
            setFieldValue('dietaryCategory2', [])
          }
        },
        className: 'form-control form-control-lg step-2  input-contract',
      },
      {
        columInput: 2,
        campo: 'dietaryCategory2',
        label: 'Categoría dietética',
        type: 'tree-select',
        style: { width: '100%' },
        treeData: propCat,
        onChangeTree: async (
          setFieldValue: any,
          values: any,
          arrayInput: any,
          currentNode: any,
          selectedNodes: any
        ) => {
          if (values.dietaryCategory2.length && values.dietaryCategory2[0].value !== '') setCatDie(values.dietaryCategory2[0])
          else setCatDie(null)
        },
        className: 'bootstrap-demo w-100',
      },
      {
        columInput: columInput,
        campo: 'mainIngredients',
        label: 'Ingredientes Principales',
        type: 'autocomplete',
        //disabled: editInput,
        disabled: props.estate.plantilla > 0 ? true : false,
        advanceOptions: {
          id: 'mainIngredients',
          placeholder: 'Ingrese Ingredientes',
          multiple: false,
          options: mapIng,
        },
        className: 'form-control form-control-lg input-contract',
        onChange: async (event: any, setFieldValue: any, values: any) => {
          const ing: any = values.mainIngredients[0]
          if (ing?.value && ing?.value != '') {
            setIngredientSelected(ing)
            if (ing?.value == '-1') props.formikProps?.setFieldValue("recipe", [{ text: 'NO APLICA', value: '-1' }])
          } else {
            setIngredientSelected(null)
          }
        },
      },
      {
        columInput: columInput,
        campo: 'recipe',
        label: 'Receta',
        type: 'autocomplete',
        onClickLabel: () => {
          const state: any = location.state
          if (state?.params) {
            const contract = {
              ...state?.params,
              id: state?.contrato,
            }
            if (contract?.plantilla === undefined)
              setInfoModal(true)
          }
        },
        //disabled: inputsDisabled,
        disabled: false,
        advanceOptions: {
          id: 'recipe',
          placeholder: 'Ingrese Receta',
          multiple: false,
          options: idMainIngredients ? quitarDuplicadoReceta(mapRecetas.filter((item: any) => item.Idtipoingprincipal == idMainIngredients),
            'rec_codigo'
          ) : mapRecetas,
        },
        className: 'form-control form-control-lg input-contract',
        onChange: async (event: any, setFieldValue: any, values: any) => {
          const rec: any = values.recipe[0]
          setRecSelected(rec)
        },
      },
      {
        columInput: columInput,
        campo: 'cycleWeek',
        label: 'Semanas',
        type: 'autocomplete',
        //disabled: editInput,
        disabled: props.estate.plantilla > 0 ? true : false,
        hideInput: hideWeeks,
        advanceOptions: {
          id: 'cycleWeek',
          placeholder: 'Seleccionar Ciclos',
          multiple: true,
          options: weeksQty, // SIEMPRE usar weeksQty que contiene TODAS las semanas disponibles
          filterBY: (option: any, props: any) => {
            // Siempre mostrar todas las opciones, incluyendo las seleccionadas
            // props contiene: { text, selected }
            return true
          },
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: columInput,
        campo: 'diaReceta',
        label: 'Días',
        type: 'autocomplete',
        //disabled: editInput,
        disabled: props.estate.plantilla > 0 ? true : false,
        advanceOptions: {
          id: 'diaReceta',
          placeholder: 'Seleccionar día',
          multiple: true,
          options: mapDays,
        },
        className: 'form-control form-control-lg input-contract',
      },
      {
        columInput: columInput,
        campo: 'intercalaryWeek',
        label: 'Tipo',
        type: 'autocomplete',
        //disabled: editInput,
        disabled: props.estate.plantilla > 0 ? true : false,
        hideInput: hideIntercalaryWeek,
        advanceOptions: {
          id: 'intercalaryWeek',
          placeholder: 'Tipo',
          multiple: false,
          options: [
            { text: 'Rotativa', value: '1' },
            { text: 'Fijo', value: '2' },
          ],
        },
        className: 'form-control form-control-lg input-contract',
      },
    ]


    // IMPORTANTE: Establecer los valores en Formik ANTES de establecer arrayInput
    // Esto asegura que TypeheadInput reciba el valor correcto desde el inicio
    if (editForm) {
      // PRIMERO limpiar el valor anterior para evitar que se muestren todas las semanas
      props.formikProps?.setFieldValue("cycleWeek", [])

      const ft = mapEstructuras.find(e => e.text === data.fatherStructure2)
      props.formikProps?.setFieldValue("fatherStructure2", [{ text: ft.text, value: ft.value }])
      props.formikProps?.setFieldValue("mainIngredients", [{ text: data.mainIngredients, value: data.idMainIngredients }])
      props.formikProps?.setFieldValue("recipe", [{ text: data.recipe, value: data.idRecipe }])
      props.formikProps?.setFieldValue("intercalaryWeek", [{ text: data.intercalaryWeek, value: data.idIntercalaryWeek }])
      setCatDie([{ text: data.dietaryCategory2, value: data.idDietaryCategory2 }])
      props.formikProps?.setFieldValue("dietaryCategory2", [{ text: data.dietaryCategory2, value: data.idDietaryCategory2 }])
      const diaReceta = data.idDiaReceta.map((e: any) => {
        return { text: mapDaysStr(e), value: e.toString() }
      })
      // Mapear las semanas seleccionadas de la receta
      const cycleWeek = data.cycleWeek.split(",").map((e: any) => {
        return { text: e.toString(), value: e.toString() }
      })
      props.formikProps?.setFieldValue("diaReceta", diaReceta)
      // Establecer solo las semanas seleccionadas de la receta como valor
      // PERO las opciones del dropdown ya tienen TODAS las semanas disponibles
      props.formikProps?.setFieldValue("cycleWeek", cycleWeek)
    } else {
      // Al crear nuevo, establecer todas las semanas como seleccionadas
      props.formikProps?.setFieldValue('cycleWeek', weeksQty)
    }

    // Ahora establecer el arrayInput con todas las semanas disponibles
    // Esto se hace DESPUÉS de establecer los valores en Formik
    setArrayInput(arrayInputToSet as propsInterfaceFormGroupInput[])

    // Forzar re-render inmediatamente para asegurar que el componente reciba las nuevas opciones
    setArrayInputKey(prev => prev + 1)
  }

  const getDaysSelected = () => {
    const { monday, tuesday, wednesday, thursday, friday, saturday, sunday } =
      props.formikProps?.values
    const arrDays = [
      { text: 'Lunes', value: '1', selectable: monday },
      { text: 'Martes', value: '2', selectable: tuesday },
      { text: 'Miercoles', value: '3', selectable: wednesday },
      { text: 'Jueves', value: '4', selectable: thursday },
      { text: 'Viernes', value: '5', selectable: friday },
      { text: 'Sabado', value: '6', selectable: saturday },
      { text: 'Domingo', value: '7', selectable: sunday },
    ]

    return arrDays.filter((e: any) => e.selectable)
  }

  const getWeeksSelected = () => {
    const { weeks } = props.formikProps?.values
    let mapCycles: options[] = []
    if (Number.isInteger(weeks)) {
      for (let i = 1; i <= weeks; i++) {
        mapCycles.push({ text: `${i}`, value: `${i}` })
      }
    }

    return mapCycles
  }

  const getRecipesByCeco = async (ceco: number) => {
    try {
      props.setLoading(true);
      const dataResp: any = await callSP('amd_getRecetaByCeco', [
        { text: 'ceco', value: ceco.toString() },
      ])
      let rec: any[] = []
      let ing: any[] = []
      const resp: any = dataResp;
      if (resp.status == '200') {
        rec = resp.data.result.map((e: any) => {
          return {
            ...e,
            text: e.rec_nombre,
            value: e.rec_codigo.toString(),
          }
        })

        ing = resp.data.result.map((e: any) => {
          return {
            ...e,
            text: e.Nombretipoingprincipal,
            value: e.Idtipoingprincipal.toString(),
          }
        })

        setRecetas(rec)
        setIngredientes(ing)
        setIngByCeco(ing)
      }
    } finally {
      props.setLoading(false);
    }
  }

  const validateAddRow = (obj: any, arr: any, isEdit: boolean) => {
    let valid = true
    const template = props.formikProps?.values.templateType[0].value
    if (arr.length) {
      if (template === 1 && !isEdit) {
        const qtyValid = arr.filter(
          (e: any) => e.fatherStructure2 == obj.fatherStructure2 && e.recipe == obj.recipe
        )

        if (qtyValid.length) {
          qtyValid.forEach((row: any) => {
            row.idCycleWeek.forEach((semana: any) => {
              if (obj.idCycleWeek.indexOf(semana) != -1) {
                row.idDiaReceta.forEach((dia: any) => {
                  if (obj.idDiaReceta.indexOf(dia) != -1) {
                    valid = false
                  }
                  if (!valid) return
                })
              }
              if (!valid) return
            })
            if (!valid) return
          })
        }
      }

      if (template === 3 && !isEdit) {
        const intercalada = props.formikProps?.values.intercalaryWeek[0].value == 1
        if (intercalada) {
          const qtyValid = arr.filter((e: any) => e.fatherStructure2 == obj.fatherStructure2)

          if (qtyValid.length) {
            let qtyRecipe: number = 0
            qtyValid.forEach((row: any) => {
              row.idDiaReceta.forEach((dia: any) => {
                if (obj.idDiaReceta.indexOf(dia) != -1) {
                  if (row.recipe == obj.recipe) {
                    valid = false
                  } else qtyRecipe += 1

                  if (qtyRecipe > 2) valid = false
                }
                if (!valid) return
              })
              if (!valid) return
            })
          }
        } else {
          const qtyValid = arr.filter(
            (e: any) => e.fatherStructure2 == obj.fatherStructure2 && e.recipe == obj.recipe
          )

          if (qtyValid.length) {
            qtyValid.forEach((row: any) => {
              row.idDiaReceta.forEach((dia: any) => {
                if (obj.idDiaReceta.indexOf(dia) != -1) {
                  valid = false
                }
                if (!valid) return
              })
              if (!valid) return
            })
          }
        }
      }

      if (!isEdit) {
        // validar estructura-semana-dia no repetido
        const arrEst: any = arr.filter((e: any) =>
          e.fatherStructure2 == obj.fatherStructure2 &&
          filterArrIncludes(obj.idCycleWeek, e.idCycleWeek) &&
          filterArrIncludes(obj.idDiaReceta, e.idDiaReceta)
        )
        if (arrEst.length) {
          valid = false
          warn(`Ya se agrego receta para la estructura ${obj.fatherStructure2} en la semana y día seleccionado`)
        }
      }
    }

    return valid
  }

  const filterArrIncludes = (arrObj: any[], arr: any[]) => {
    let valid: boolean = false
    arr.forEach((e: any) => {
      if (arrObj.includes(e)) valid = true
    })

    return valid
  }

  const clearInput = (id: string, obj: any) => {
    props.formikProps?.setFieldValue(id, [{ text: '', value: '' }])
    obj[id][0] = { text: '', value: '' }
  }

  const validateAdd = (values: any) => {
    if (!isValid(values, 'fatherStructure2', 'Debe selecionar estructura padre')) return false
    if (!isValid(values, 'dietaryCategory2', 'Debe selecionar categoria dietetica')) return false
    if (!isValid(values, 'mainIngredients', 'Debe selecionar ingrediente principal')) return false
    if (!isValid(values, 'recipe', 'Debe selecionar receta')) return false
    if (!isValid(values, 'diaReceta', 'Debe selecionar al menos un día')) return false

    if (values.templateType[0].value != '3') {
      if (!isValid(values, 'cycleWeek', 'Debe selecionar al menos una semana')) return false
    }

    if (values.templateType[0].value == '3') {
      if (!isValid(values, 'intercalaryWeek', 'Debe indicar si la semana es intercalada'))
        return false
    }

    return true
  }

  useEffect(() => {
    if (!addRow) {
      return
    }
    addGridReceta(false)
  }, [open])

  const addGridReceta = async (edit: boolean) => {
    let obj = props.formikProps?.values
    let tipoPlan3: boolean = props.formikProps?.values.templateType[0].value == '3'

    if (validateAdd(obj)) {
      let row = dataRow3.slice()
      obj.id = row.length
      let formContract3: contStep3 = {
        cycleWeek: obj.cycleWeek && Array.isArray(obj.cycleWeek) && obj.cycleWeek.length
          ? obj.cycleWeek.map((e: any) => e.text).join(',')
          : 'No aplica',
        idCycleWeek: obj.cycleWeek && Array.isArray(obj.cycleWeek)
          ? obj.cycleWeek.map((e: any) => e.value)
          : [],
        fatherStructure2: obj.fatherStructure2[0].text,
        id: obj.id,
        idDelete: 0,
        data: JSON.parse(JSON.stringify(obj)),
        mainIngredients: obj.mainIngredients[0].text,
        idMainIngredients: obj.mainIngredients[0].value,
        recipe: obj.recipe[0].text,
        idRecipe: obj.recipe[0].value,
        diaReceta: obj.diaReceta.map((e: any) => e.text).join(','),
        idDiaReceta: obj.diaReceta.map((e: any) => e.value),
        intercalaryWeek: tipoPlan3 ? obj.intercalaryWeek[0].text : 'No',
        idIntercalaryWeek: tipoPlan3 ? obj.intercalaryWeek[0].value : '2',
        dietaryCategory2: obj.dietaryCategory2[0]?.tagLabel ? obj.dietaryCategory2[0]?.tagLabel : obj.dietaryCategory2[0].text,
        dietaryCategory2All: obj.dietaryCategory2[0]?.tagLabel,
        idDietaryCategory2: obj.dietaryCategory2[0].value,
        idRecetaFija: obj.idRecetaFija,
      }
      let totalEstructuraPadre: any = []
      let fatherStructure: any = []
      let diasBloqueados2: any = []
      dataRow2.forEach((item: any, key: number) => item.idDelete = key)
      dataRow2.map((item: any) => {
        if (totalEstructuraPadre[item.idStructure] === undefined) {
          totalEstructuraPadre[item.idStructure] = 0
          fatherStructure.push(item.idStructure)
        }
        item.data.blockedDays?.map((day: any) => {
          if (diasBloqueados2[item.idStructure.toString()] === undefined && day.text !== '') {
            diasBloqueados2[item.idStructure.toString()] = 0
          }
          diasBloqueados2[item.idStructure.toString()] += props.formikProps?.values.weeks
        })
      })
      if (props.formikProps?.values.diaReceta[0]?.text !== '') {
        const diasB = diasBloqueados2[props.formikProps?.values.fatherStructure2[0].text]
        if (
          props.formikProps?.values.diaReceta.length * props.formikProps?.values.weeks >
          props.formikProps?.values.frequencyCycle - diasB
        ) {
          warn(
            'La frecuencia no debe superar ' + (props.formikProps?.values.frequencyCycle - diasB)
          )
          return
        }
      }
      const { total, diasBloqueados } = validateIngredientsFrequency(
        dataRow3,
        [],
        props.formikProps?.values,
        dataRow2,
        props.data.ingAdyacentes,
      )
      let totalBloqueados = diasBloqueados[props.formikProps?.values.fatherStructure2[0]?.text]

      if (isNaN(totalBloqueados)) {
        totalBloqueados = 0
      }
      if (props.formikProps?.values.frequencyCycle - totalBloqueados < total) {
        warn(
          'La frecuencia no debe superar ' +
          (props.formikProps?.values.frequencyCycle - totalBloqueados)
        )
        return
      }

      if (validateAddRow(formContract3, row, edit)) {
        clearInput('fatherStructure2', obj)
        clearInput('mainIngredients', obj)
        clearInput('recipe', obj)
        clearInput('intercalaryWeek', obj)
        clearInput('dietaryCategory2', obj)

        setEstrPadre(null)
        setCatDie(null)

        props.formikProps?.setFieldValue('diaReceta', [])
        props.formikProps?.setFieldValue('cycleWeek', [])
        const idRow = await getLStorage("idEdit");
        if (!edit) {
          row.push(formContract3)
          if (recSelected && recSelected.IdSegundoIngredientePrincipal > 0) {
            const recFinded: any = estPadre.find((e: any) => e.pf_nombre.includes(formContract3.fatherStructure2) || e.ac_nombre.includes(formContract3.fatherStructure2))
            if (recFinded) {
              let copyFormContract3: contStep3 = {
                cycleWeek: formContract3.cycleWeek,
                idCycleWeek: formContract3.idCycleWeek,
                fatherStructure2: formContract3.fatherStructure2?.includes('Plato') ? recFinded.ac_nombre : recFinded.pf_nombre,
                id: edit ? idRow : row.length,
                idDelete: 0,
                data: JSON.parse(JSON.stringify(obj)),
                mainIngredients: recSelected.NombreSegundoIngredientePrincipal,
                idMainIngredients: recSelected.IdSegundoIngredientePrincipal,
                recipe: formContract3.recipe,
                idRecipe: formContract3.idRecipe,
                diaReceta: formContract3.diaReceta,
                idDiaReceta: formContract3.idDiaReceta,
                intercalaryWeek: formContract3.intercalaryWeek,
                idIntercalaryWeek: formContract3.idIntercalaryWeek,
                dietaryCategory2: formContract3.dietaryCategory2,
                dietaryCategory2All: formContract3.dietaryCategory2All,
                idDietaryCategory2: formContract3.idDietaryCategory2,
                idRecetaFija: formContract3.idRecetaFija,
              }

              get_set_ls("recFij", formContract3.idRecetaFija)
              get_set_ls("recFijRec", formContract3.idRecipe)
              get_set_ls("recFijCD", formContract3.idDietaryCategory2)

              row.forEach((item: any, key: number) => item.idDelete = key)
              row.push(copyFormContract3)
            }
          }
          row.forEach((item: any, key: number) => item.idDelete = key)

          setDataRow3(row)
          setIsAdd(true)
        } else {
          const newStore = dataRow3.slice();
          if (idRow !== undefined) {

            // Buscar TODOS los idRecetaFija que tienen el mismo id_receta que se está editando
            // IMPORTANTE: Usar el id_receta ORIGINAL (rowSelected.idRecipe) no el nuevo (formContract3.idRecipe)
            // porque necesitamos actualizar todos los registros de la receta original
            const idRecetaOriginal = rowSelected?.idRecipe || formContract3.idRecipe
            const estructuraEditando = rowSelected?.fatherStructure2 || formContract3.fatherStructure2

            const todasLasRecetasFijasConMismoIdReceta = props.data.recetaFija?.filter((recf: any) => {
              const coincideIdReceta = recf.id_receta?.toString() === idRecetaOriginal?.toString()
              const coincideEstructura = recf.estructura === estructuraEditando
              return coincideIdReceta && coincideEstructura
            }) || []

            // Guardar TODOS los idRecetaFija encontrados
            // IMPORTANTE: 
            // - recFij: idRecetaFija de la receta ORIGINAL (para identificar qué registros actualizar)
            // - recFijRec: id_receta de la NUEVA receta seleccionada (para actualizar a la nueva receta)
            // - recFijCD: categoría dietética de la nueva receta
            todasLasRecetasFijasConMismoIdReceta.forEach((recf: any) => {
              if (recf.idRecetaFija) {
                get_set_ls("recFij", recf.idRecetaFija)
              }
              // Guardar el id_receta de la NUEVA receta seleccionada (no la original)
              // Esto es lo que se usará para actualizar los registros
              if (formContract3.idRecipe) {
                get_set_ls("recFijRec", formContract3.idRecipe)
              }
              // Guardar la categoría dietética de la nueva receta
              if (formContract3.idDietaryCategory2) {
                get_set_ls("recFijCD", formContract3.idDietaryCategory2)
              }
            })

            // Verificar que se guardaron correctamente
            const recFijGuardado = getLStorage('recFij')
            const recFijRecGuardado = getLStorage('recFijRec')
            const recFijCDGuardado = getLStorage('recFijCD')

            const newData = newStore.map((item: any) => {
              const idDiaReceta = item.idDiaReceta.join(',')
              //if (item.id === idRow) {
              if (
                item.fatherStructure2 == rowSelected.fatherStructure2
                && item.idMainIngredients == rowSelected.idMainIngredients
                && item.cycleWeek == rowSelected.cycleWeek
                && idDiaReceta == rowSelected.idDiaReceta) {

                return formContract3
              }
              return item;
            });
            //newData.forEach((item: any, key: number) => { item.idDelete = key; item.id = key })

            setDataRow3(newData)
            gridRef?.current?.api?.setRowData(newData)
          }
        }
      } else {
        warn('Receta ya ha sido agregada!')
      }
    }
  }

  const filter = useCallback(async (params: any) => {
    props.formikProps?.setFieldValue('recipe', [{ text: params.data.text, value: params.data.value }])
    setInfoModal(false)
  }, [])

  const editRecetaFija = useCallback(() => {
    addGridReceta(true)
    setBtnStructure(props.title)
  }, [props.formikProps])

  return (
    <div className='w-100'>
      <div className=''>
        <h2 className='text-dark'>{props.title}</h2>
        <div className='text-gray-400 fw-bold fs-6'>{props.subTitle}</div>
      </div>
      <hr />

      <ArrayInput key={arrayInputKey} classContainer='container-input' arrayInput={arrayInput} />

      <Button
        className='btn-agregar'
        type='button'
        onClick={() => {

          setSStorage("idMainIngredients", '')
          setSStorage("weeksQty", '')
          setLStorage('idRecetaFija', '')
          if (btnStructure === 'Editar receta fija') {
            let r = !open
            editRecetaFija()
            setAddRow(true)
          } else {
            let r = !open
            setAddRow(true)
            setOpen(r)
          }
        }}
      >
        {btnStructure}
      </Button>

      <AgGridTable rowHeight={90} columnDefs={columnDefs} dataRow={dataRow3} setAGGridRef={setGridRef} />

      {showModal && (
        <ModalForm
          initialValues={initValuesModal}
          show={showModal}
          onSubmit={(_value, formikProps) => {
            setTimeout(() => {
              setShowModal(false)
            }, 500)
          }}
          close={() => {
            setShowModal(false)
          }}
          save={() => { }}
          title={'Seleccionar días'}
          arrayInput={arrayInputModal}
          classArrayInput='container-input ckeckbox-reglas'
        />
      )}

      {infoModal && (
        <ModalForm
          colum={getColumRecetaGrid(filter)}
          showSave={false}
          showClose={false}
          showAddButton={false}
          modalFullscreen={true}
          title={'Seleccionar Estructura'}
          rows={mapRec}
          show={infoModal}
          saveName={'Seleccionar Estructura'}
          close={() => {
            setInfoModal(false)
          }}
          save={() => {
            setInfoModal(false)
          }}
        />
      )}
    </div>
  )
}

export interface contStep3 {
  id?: number
  fatherStructure2?: string
  mainIngredients?: string
  idMainIngredients?: number
  recipe?: string
  idRecipe?: number
  cycleWeek?: string
  idCycleWeek?: string | any[]
  data?: any
  idDelete?: number
  diaReceta: any
  idDiaReceta?: any
  intercalaryWeek?: string
  idIntercalaryWeek?: string
  dietaryCategory2?: string
  dietaryCategory2All?: string
  idDietaryCategory2?: number
  load?: boolean
  idRecetaFija?: string | number
}

interface StepContract3Props {
  title?: string
  subTitle?: string
  onChange?(e: React.ChangeEvent<HTMLInputElement>): void
  formikProps?: FormikProps<any>
  data?: any
  isReady?: boolean
  reload3: boolean,
  setLoading: any,
  estate?: any
}

export { StepContract3 }
